import { useEnvironment } from '@/react/portainer/environments/queries/useEnvironment';
import { EnvironmentId } from '@/react/portainer/environments/types';

// Reads the applied policy rather than probing for trivy CRDs: uninstalling the
// scanner leaves its CRDs and reports behind, so a probe would keep showing
// findings for a scanner that is gone.
export function useIsVulnerabilityScanningEnabled(
  environmentId?: EnvironmentId
) {
  return useEnvironment(
    environmentId,
    (environment) =>
      !!environment.Policies?.k8sVulnerabilityScanningPolicy?.policyID
  );
}
